export const environment = {
  apiBase: 'api.express.dreambookspro.com',
  apiUrl: 'https://api.express.dreambookspro.com/api',
  //apiBase: 'express.dev.corp.lfmcorporate.com',
  //apiUrl: 'https://api.express.dev.corp.lfmcorporate.com/api',
  // Standalone guest preview app host (prod).
  previewBaseUrl: 'https://editorpreview.com',
  // Viva Smart Checkout base — live environment.
  vivaUrl: 'https://www.vivapayments.com/web/checkout',
  vivaColorCode: '2f5a45',
  production: true,
};
